// extracted by mini-css-extract-plugin
export var modalFooter = "_qo-0";